import { FC } from 'react'

import classNames from 'classnames'
import s from './Quiz.module.scss'

type FinishProps = {
    title: string
    description: string
    isLoading: boolean
    onClose: () => void
}

const Finish: FC<FinishProps> = ({ title, isLoading, description, onClose }) => {
    return (
        <div className={s.quizPopup__finish}>
            {isLoading ? (
                'Загрузка...'
            ) : (
                <>
                    <h3 className={classNames(s.quizPopup__title, s.quizPopup__title_finish)}>{title}</h3>
                    <p className={s.quizPopup__descr}>{description}</p>
                    <button
                        onClick={onClose}
                        className={classNames('button-more', s.quizPopup__finishBtn)}
                    >
                        Завершить
                    </button>
                </>
            )}
        </div>
    )
}

export default Finish
